const accordionBlock = ( $ ) => {
	$( '.accordion-block__icon' ).click( function ( e ) {
		e.preventDefault();
	} );
	$( '[data-accordion-trigger]' ).on( 'click', function () {
		const currentItem = $( this ).closest( '[data-accordion-item]' );
		const currentPanel = currentItem.find( '.accordion-block__panel' );

		// Close all
		$( '[data-accordion-item]' )
			.not( currentItem )
			.removeClass( 'is-open' )
			.find( '.accordion-block__panel' )
			.slideUp();

		// Toggle current
		if ( currentItem.hasClass( 'is-open' ) ) {
			currentItem.removeClass( 'is-open' );
			currentPanel.slideUp();
		} else {
			currentItem.addClass( 'is-open' );
			currentPanel.slideDown();
		}
	} );
};

export default ( ( $ ) => $( accordionBlock ) )( jQuery );
